var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('content-section',{staticClass:"form-section mt-12",scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',[_vm._v("Overview")]),_vm._v(" "),_c('div',{staticClass:"italic text-sm text-grey-700"},[_c('p',[_vm._v("The competitions general settings")])])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"-mx-6 flex flex-wrap -mb-8"},[_c('input-default',{attrs:{"input":{
          'key':'competition.title',
          'type':'text',
          'label':'Competition title',
          'instructions':null,
          'attributes':{
            'placeholder':'Your project\'s title',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'2/3'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.competition.title},on:{"update:input":_vm.input}}),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.published_at',
          'type':'date',
          'label':'Publish date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/3'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.published_at)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('h3',{staticClass:"w-full mx-6 mb-2 text-base"},[_vm._v("\n        Competition Duration\n      ")]),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.start_date',
          'type':'date',
          'label':'Start date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.start_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.end_date',
          'type':'date',
          'label':'End date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.end_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('h3',{staticClass:"w-full mx-6 mb-2 text-base"},[_vm._v("\n        Application Phase\n      ")]),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.application_start_date',
          'type':'date',
          'label':'Publish date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.application_start_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.application_end_date',
          'type':'date',
          'label':'End date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.application_end_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('h3',{staticClass:"w-full mx-6 mb-2 text-base"},[_vm._v("\n        Contract Phase\n      ")]),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.contracting_start_date',
          'type':'date',
          'label':'Publish date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.contracting_start_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('input-default',{attrs:{"input":{
          'key':'competition.contracting_end_date',
          'type':'date',
          'label':'End date',
          'instructions':null,
          'attributes':{
            'placeholder':'',
            'default':null,
            'prepend':null,
            'append':null,
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'1/2'
          },
          'validation':{
            'min':_vm.dateInputFormat(_vm.competition.contracting_start_date),
            'max':_vm.dateInputFormat(_vm.competition.end_date),
            'limit':false
          }
        },"application-value":_vm.dateInputFormat(_vm.competition.contracting_end_date)},on:{"update:input":_vm.input}}),_vm._v(" "),_c('input-multiline',{attrs:{"input":{
          'key':'competition.overview',
          'type':'multiline',
          'label':'Overview',
          'instructions':'',
          'attributes':{
            'placeholder':'',
            'default':'',
            'prepend':'',
            'append':'',
            'locked':false,
            'required':true
          },
          'wrapper':{
            'width':'full'
          },
          'validation':{
            'min':false,
            'max':false,
            'limit': 1000
          }
        },"application-value":_vm.competition.overview},on:{"update:input":_vm.input}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }